import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class FileStorageService {
    constructor(private http: HttpClient) {}

    uploadFile(fileData: File | Blob, fileName: string, storage: string): Observable<FileUploadResponse> {
        const formData = new FormData();
        formData.append("file", fileData, fileName);
        formData.append("storage", storage);

        return this.http.post<FileUploadResponse>("/files/upload", formData);
    }
}

export interface FileUploadResponse {
    url: string;
    fileName: string;
    fileSize: number;
    contentType?: string;
    uploadedAt?: Date;
}
